/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Kargo_EtiketiInputs */

const tr_faq_a_kargo_etiketi = /** @type {(inputs: Faq_A_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş onaylandıktan sonra Kargo Etiketi butonuyla PDF etiketi indirebilir ve yazdırabilirsin. Ayarlar altındaki Kargo Etiketi sayfasından etiket boyutunu ve yazıcı türünü seçebilirsin. Trendyol ve Hepsiburada etiketleri direkt pazaryeri API'sinden çekilir.`)
};

const en_faq_a_kargo_etiketi = /** @type {(inputs: Faq_A_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After approving an order, click Shipping Label to download a PDF and print it. You can choose the label size and printer type on the Label Settings page under Settings. Trendyol and Hepsiburada labels are fetched directly from the marketplace API.`)
};

const de_faq_a_kargo_etiketi = /** @type {(inputs: Faq_A_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach der Genehmigung einer Bestellung klicke auf Versandetikett, um ein PDF herunterzuladen und zu drucken. Etikettengröße und Druckertyp kannst du unter Einstellungen festlegen. Trendyol- und Hepsiburada-Etiketten werden direkt über die Plattform-API abgerufen.`)
};

const ru_faq_a_kargo_etiketi = /** @type {(inputs: Faq_A_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После одобрения заказа нажмите Этикетка доставки, чтобы скачать PDF и распечатать его. Размер этикетки и тип принтера выбираются в Настройках. Этикетки Trendyol и Hepsiburada загружаются напрямую из API площадки.`)
};

/**
* | output |
* | --- |
* | "After approving an order, click Shipping Label to download a PDF and print it. You can choose the label size and printer type on the Label Settings page unde..." |
*
* @param {Faq_A_Kargo_EtiketiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_kargo_etiketi = /** @type {((inputs?: Faq_A_Kargo_EtiketiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Kargo_EtiketiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_kargo_etiketi(inputs)
	if (locale === "de") return de_faq_a_kargo_etiketi(inputs)
	if (locale === "ru") return ru_faq_a_kargo_etiketi(inputs)
	return tr_faq_a_kargo_etiketi(inputs)
});